



















































































import { Component, Watch, Vue } from 'vue-property-decorator';
import FlagsService from '@/api/FlagsService';
import Checkbox from '@/components/Checkbox/Checkbox.vue';
import ContentContainer from '@/components/molecules/ContentContainer/ContentContainer.vue';
import Table from '@/components/molecules/Table/Table.vue';
import TableCell from '@/components/molecules/TableCell/TableCell.vue';
import TableHeader from '@/components/molecules/TableHeader/TableHeader.vue';
import TableRow from '@/components/molecules/TableRow/TableRow.vue';
import { HeaderList } from '@/components/Table/TableModel';
import { treatError } from '@/utils';
import ContextMenu from '@/components/ContextMenu/ContextMenu.vue';
import ContextMenuOption from '@/components/ContextMenu/ContextMenuOption';
import TableFilters from '@/components/molecules/TableFilters/TableFilters.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import TextInput from '@/components/TextInput/TextInput.vue';
import Row from '@/components/atoms/Grid/Row.vue';
import eventBus from '@/utils/eventBus';
import { IFlag } from '@/views/Admin/FlagsList/FlagListType';
import { Pagination, SortController } from '@/utils/Pagination';
import FeatureFlagStatus, { IFeatureFlag } from './FeatureFlagStatus.vue';

@Component({
  components: {
    FilledButton,
    ContextMenu,
    Checkbox,
    ContentContainer,
    Table,
    TableCell,
    TableHeader,
    TableRow,
    TableFilters,
    TextInput,
    Row,
    FeatureFlagStatus
  }
})
export default class FlagsList extends Vue {
  loadingAllEnvStatus: boolean = false;
  allFeatureFlags: Record<string, IFeatureFlag> = {};
  service: FlagsService = new FlagsService();
  pagination = new Pagination();
  sort = new SortController();
  query: any = {
    searchableFields: ['name', 'slug']
  };
  headers = [
    new HeaderList(`Slug`, 'slug'),
    new HeaderList(`Name`, 'name'),
    new HeaderList(`Environments`, 'status'),
    new HeaderList(`Status`, 'status')
  ];

  updateSort(field: string) {
    this.sort.update(field);
    const { sortOrder, sortBy } = this.sort.toQueryParams();
    this.query = {
      ...this.query,
      sortBy,
      sortOrder
    };
  }

  updateSearch(search: string) {
    this.query = {
      ...this.query,
      search
    };
  }

  @Watch('query')
  refreshPagination(query: any) {
    this.pagination.refresh('/super-admin/feature-flag', query, 500);
  }

  mounted() {
    this.refreshPagination(this.query);
    this.updateAllEnvStatus();
    this.pagination.setPaginationTarget(this.$refs.target as HTMLElement);
    eventBus.$on('setSideModalVisible', (args: any) => {
      if (!args.isOpen) {
        this.refreshPagination(this.query);
      }
    });
  }

  get contextMenuOptions() {
    return [
      new ContextMenuOption('toggle_all', 'Toggle for all'),
      new ContextMenuOption('toggle_group', 'Edit tester group')
    ];
  }

  handleAction(action: string, flag: IFlag) {
    switch (action) {
      case 'toggle_all':
        return this.toggleForAll(flag);
    }
  }

  openNewFlagModal() {
    eventBus.$emit('setSideModalVisible', {
      isOpen: true,
      component: 'newFlagModal'
    });
  }

  openEditFlagModal(flag: IFlag) {
    eventBus.$emit('setSideModalVisible', {
      isOpen: true,
      component: 'editFlagModal',
      data: flag
    });
  }

  async toggleForAll(flag: IFlag) {
    this.toggleStatus(flag);
    try {
      await this.service.changeStatus(flag.id, {
        status: flag.status,
        groups: []
      });
    } catch (e) {
      this.$notification(treatError(e));
      this.toggleStatus(flag); // Go back to previous state
    }
  }

  getFeatureFlagStatus(slug: string) {
    return this.allFeatureFlags &&
      !this.loadingAllEnvStatus &&
      this.allFeatureFlags[slug]
      ? this.allFeatureFlags[slug]
      : {
          dev: 'unavailable',
          production: 'unavailable',
          staging: 'unavailable',
          qa: 'unavailable',
          slug
        };
  }

  async updateAllEnvStatus(refresh = false) {
    this.loadingAllEnvStatus = true;

    if (refresh) {
      await this.service.refreshAllFlagsForAllEnvs();
    }

    this.allFeatureFlags = await this.getAllFeatureFlagStatus();

    this.loadingAllEnvStatus = false;
  }

  async getAllFeatureFlagStatus() {
    try {
      const { data } = await this.service.getAllFlagsForAllEnvs();
      return data;
    } catch (e) {
      console.error(treatError(e));
    }
  }

  toggleStatus(flag: IFlag) {
    flag.status = flag.status === 'enabled' ? 'disabled' : 'enabled';
  }

  getFlagStatusColor(flag: IFlag) {
    if (flag.status === 'enabled') return 'green';
    return 'yellow';
  }

  isFlagChecked(flag: IFlag) {
    if (flag.status === 'enabled') {
      return true;
    }
    if (flag.groups && flag.groups[0]) {
      if (flag.groups[0].businesses && flag.groups[0].businesses.length > 0) {
        return true;
      }
      if (flag.groups[0].customers && flag.groups[0].customers.length > 0) {
        return true;
      }
    }
    return false;
  }
}
